/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { parentId, isEditionAuthorized, isDeletionAuthorized, openSubCourseListPage, openEditCoursePage, deleteCourses }
) => (
  <>
    {
      !parentId &&
      <OverlayTrigger
        overlay={<Tooltip id="sub-course-list-tooltip">Alt Ders Listesi</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          onClick={() => openSubCourseListPage(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Text/Article.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    }    
    {
      isEditionAuthorized &&
      <OverlayTrigger
        overlay={<Tooltip id="course-edit-tooltip">Düzenle</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm ml-3"
          onClick={() => openEditCoursePage(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    }
    {
      isDeletionAuthorized &&
      <OverlayTrigger
        overlay={<Tooltip id="course-delete-tooltip">Sil</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm ml-3"
          onClick={() => deleteCourses(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    }    
  </>
);